import React from "react";
import RecordManager from "../../../components/founder/RecordManager";

export default function ImplementationTab({ ws, bid, reload }) {
  return (
    <div className="space-y-8 max-w-4xl">
      <div className="lr-card p-5">
        <RecordManager
          resource="projects" bid={bid} items={ws.projects} testid="projects-manager"
          title="Implementation Projects" addLabel="Add project" onChange={reload}
          fields={[
            { name: "name", label: "Project name", type: "text" },
            { name: "linked_intervention", label: "Linked intervention", type: "text" },
            { name: "scope", label: "Scope", type: "textarea", rows: 3 },
            { name: "status", label: "Status", type: "select", options: ["Planning", "Building", "Client Review", "Live", "Monitoring", "Complete"] },
            { name: "price", label: "Price", type: "text" },
            { name: "deadline", label: "Deadline", type: "text" },
            { name: "deliverables", label: "Deliverables", type: "textarea", rows: 2 },
            { name: "recurring", label: "Recurring maintenance", type: "select", options: ["Yes", "No"] },
            { name: "notes", label: "Notes", type: "textarea", rows: 2 },
          ]}
          renderItem={(p) => (
            <div className="space-y-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-medium text-lr-charcoal">{p.name}</span>
                <span className="text-xs px-1.5 py-0.5 rounded-[3px] bg-lr-clay/15 text-lr-clay">{p.status || "Planning"}</span>
                {p.price && <span className="text-xs text-lr-leather">{p.price}</span>}
              </div>
              {p.scope && <div className="text-sm text-lr-charcoal">{p.scope}</div>}
            </div>
          )}
        />
      </div>

      <div className="lr-card p-5">
        <RecordManager
          resource="care_plans" bid={bid} items={ws.care_plans} testid="care-plans-manager"
          title="Care Plans" addLabel="Add care plan" onChange={reload}
          fields={[
            { name: "monthly_price", label: "Monthly price", type: "text" },
            { name: "services_included", label: "Services included", type: "textarea", rows: 3 },
            { name: "status", label: "Status", type: "select", options: ["Active", "Paused", "Cancelled"] },
            { name: "renewal_date", label: "Renewal date", type: "text" },
            { name: "last_review", label: "Last review", type: "text" },
            { name: "next_review", label: "Next review", type: "text" },
            { name: "open_issues", label: "Open issues", type: "textarea", rows: 2 },
          ]}
          renderItem={(c) => (
            <div className="space-y-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-medium text-lr-charcoal">{c.monthly_price || "Not set"}/mo</span>
                <span className="text-xs px-1.5 py-0.5 rounded-[3px] bg-lr-olive/12 text-lr-olive">{c.status || "Active"}</span>
              </div>
              {c.services_included && <div className="text-sm text-lr-charcoal">{c.services_included}</div>}
            </div>
          )}
        />
      </div>
    </div>
  );
}
